import { appStore } from '@/utils/jotaiStore';
import { atom } from 'jotai';

// Set by a control asking for the palette. The palette opens on it when it mounts or sees it
// change, and clears it.
export const paletteOpenRequestedAtom = atom(false);

// Set when the palette failed to load, so controls that open it can step aside.
export const paletteUnavailableAtom = atom(false);

export const requestPaletteOpen = () => appStore.set(paletteOpenRequestedAtom, true);
